/* src/app/features/honra/protocolo/solicitacao-honra-cadastro.component.scss */
.opcoes {
  padding: 10px;
  border: 1px solid lightgrey;
}
.opcao {
  margin-left: 20px;
  color: steelblue;
}
/*# sourceMappingURL=solicitacao-honra-cadastro.component.css.map */
